import React, { useContext, useEffect, useState } from 'react';

import HomeCarousel from '../components/HomeCarousel';
import ReviewCarousel from '../domain/Review/Carousel/ReviewCarousel';

import PageTemplate from '../components/common/template/PageTemplate';
import { Flex } from '../components/common/atom/Layout';
import { Text } from '../components/common/atom/Text';
import { Card } from '../components/common/organism/Card';
import {
  BABYFACE_DETAIL_MENU,
  CLEARFACE_DETAIL_MENU,
} from '../components/common/organism/Drawer';

import ThemeStyle from '../lib/style/ThemeStyle';
import {
  BabyfacePreviewImage,
  ClearfacePreviewImage,
} from '../lib/image/HomeImages';
import { getBabyfaceItemPrice } from '../domain/Sales/Item/BabyfaceAPI';

const HomePage = () => {
  const [babyfacePrice, setBabyfacePrice] = useState('');

  useEffect(() => {
    getBabyfaceItemPrice().then((price) => {
      setBabyfacePrice(`${price.toLocaleString()}원`);
    });
  }, []);

  return (
    <PageTemplate noMargin>
      <HomeCarousel />
      <Flex
        column
        padding={`1.25rem 1.25rem 2.5rem`}
        style={{ background: ThemeStyle.background.grey }}
      >
        <Flex column alignItems="flex-start" style={{ width: '100%' }}>
          <Text weight="bold">상품소개</Text>
          <Text
            size={12}
            color="caption"
            style={{ margin: `0.3125rem 0 0.625rem` }}
          >
            입체초음파를 완성하는 알레시오만의 AI 기술
          </Text>
          <Flex>
            <Card
              img={BabyfacePreviewImage}
              path={BABYFACE_DETAIL_MENU.path}
              title={BABYFACE_DETAIL_MENU.label}
              content="입체초음파를 분석하여 실제 아기 얼굴 예측"
            />
            <Card
              img={ClearfacePreviewImage}
              path={CLEARFACE_DETAIL_MENU.path}
              title={CLEARFACE_DETAIL_MENU.label}
              content="흐릿하고 가려진 입체초음파를 선명하게 복원"
            />
          </Flex>
        </Flex>
      </Flex>
      <ReviewCarousel />
    </PageTemplate>
  );
};

export default React.memo(HomePage);
